// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__30K6h","notes":"Notes_notes__2TMpe","note":"Notes_note__35IyD","markdown":"Notes_markdown__Ju2gb"};